import "../../assets/card.scss";

import { getAppealPreview } from "@teams/cards";
import { TeamsApplicationTypes, TeamsSurveyDraft, TeamsUser } from "@teams/types";
import { useCallback, useEffect, useMemo, useState } from "react";

import { ReactHTMLElement } from "../../../../../../_shared/components/ReactHTMLElement";
import { useButton, useTheme } from "../../hooks";
import { SurveyTakingPreview } from "../SurveyTakingPreview";

type Props = {
  draft: TeamsSurveyDraft;
  owner: TeamsUser;
  applicationType: TeamsApplicationTypes;
  tenantId: string;
};

export const SurveyPreview: React.FC<Props> = props => {
  const [showPopup, setShowPopup] = useState(false);

  const cardHtml = useMemo(() => {
    const card = getAppealPreview(props.draft, props.owner, props.tenantId, props.applicationType, {
      addQuestions: false,
      hideDetailsBar: false,
    });

    const html = card.render()!;

    return html;
  }, [props.applicationType, props.draft, props.owner, props.tenantId]);

  useTheme(cardHtml);

  useEffect(() => {
    const separator = (
      cardHtml?.getElementsByClassName(
        "ac-horizontal-separator"
      ) as HTMLCollectionOf<HTMLDivElement>
    )?.[0];

    if (!separator) {
      return;
    }

    separator.style.marginTop = "-10px";
  }, [cardHtml]);

  const { removeClickHandler, buttonLabels } = useButton(cardHtml);

  useEffect(() => {
    removeClickHandler(buttonLabels.ViewAllResultsButtonLabel);
  }, [buttonLabels.ViewAllResultsButtonLabel, removeClickHandler]);

  const getStartButton = useCallback(() => {
    const buttons = cardHtml.getElementsByTagName("button");
    return buttons.item(0);
  }, [cardHtml]);

  useEffect(() => {
    const startButton = getStartButton();

    if (!startButton) {
      return;
    }

    startButton.onclick = e => {
      e.preventDefault();
      setShowPopup(true);
    };
  }, [getStartButton]);

  if (showPopup) {
    return (
      <SurveyTakingPreview
        draft={props.draft}
        owner={props.owner}
        applicationType={props.applicationType}
        tenantId={props.tenantId}
        closePopupHandler={() => setShowPopup(false)}
      />
    );
  } else {
    return (
      <div className="card">
        <ReactHTMLElement html={cardHtml} />
      </div>
    );
  }
};
